module.exports = __webpack_public_path__ + "static/media/dwarven-gold-deluxe.9e2b87f7.gif";